import { FC } from 'react';
import { Box, TextField } from '@mui/material';
import { Control, Controller, FieldErrors, UseFormSetValue } from 'react-hook-form';
import { FormData } from '../constants';

type Props = {
	formWatch: FormData;
	control: Control<FormData>;
	errors: FieldErrors<FormData>;
	setValue: UseFormSetValue<FormData>;
};

const DayOfMonthInput: FC<Props> = ({ formWatch, control, errors, setValue }) => {
	return (
		<>
			{formWatch.recurrenceType === 'MONTHLY' || formWatch.recurrenceType === 'YEARLY' ? (
				<Box>
					<Controller
						name="dayOfMonth"
						control={control}
						render={() => (
							<TextField
								id="day-of-month"
								label="Day of Month"
								type="number"
								value={formWatch.dayOfMonth}
								onChange={(evt) =>
									setValue('dayOfMonth', Number(evt.target.value), { shouldValidate: true })
								}
								fullWidth
								sx={{ marginBottom: '1rem' }}
								error={!!errors.dayOfMonth}
								helperText={errors.dayOfMonth?.message}
								slotProps={{
									inputLabel: {
										shrink: true,
									},
									htmlInput: {
										min: 1,
										max: 28,
									},
								}}
							/>
						)}
					/>
				</Box>
			) : (
				''
			)}
		</>
	);
};

export default DayOfMonthInput;
